import React, { useEffect, useState, useRef } from 'react';
import SubmitButton from '../../shared/SubmitButton';
import { Icon } from '@iconify/react';
import { showToastMessage, buttonLoadingClass, executeLaravelAPI, userToken} from '../../Utils';

const ProjectUspTab = ({ selectedProjectId }) => {
  const buttonClass = useRef('theme-btn btn btn-success');
  const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
  const [usps, setUsps] = useState([{ id: 'newusp1', text: '' }]);
  const [removedIds, setRemovedIds] = useState([]);

  useEffect(() => {    
      const getUSPs = async () => {
          try {
              const result = await executeLaravelAPI(`projectusps/${selectedProjectId}`, '', 'GET', userToken);
              
              // Validate the response structure
              if (result && result.data && Array.isArray(result.data)) {
                  // If array is empty, keep at least one empty row
                  if (result.data.length === 0) {
                      setUsps([{ id: 'newusp1', text: '' }]);
                  } else {
                      setUsps(result.data);
                  }
              } else if (result && Array.isArray(result)) {
                  // Handle case where result is directly an array
                  if (result.length === 0) {
                      setUsps([{ id: 'newusp1', text: '' }]);
                  } else {
                      setUsps(result);
                  }
              } else {
                  // If no valid data, keep default empty row
                  setUsps([{ id: 'newusp1', text: '' }]);
              }
          } catch (error) {
              console.error('Error fetching data:', error);
              // Show user-friendly error message
              if (error.message && error.message.includes('Failed to fetch')) {
                  showToastMessage('Connection failed. If the problem persists, please check your internet connection or VPN', 'top-right', 'error');
              } else {
                  showToastMessage('Failed to load USPs. Please try again.', 'top-right', 'error');
              }
              // Keep default empty row so component doesn't break
              setUsps([{ id: 'newusp1', text: '' }]);
          }
      };
      if (selectedProjectId) {
          getUSPs();
      }
  }, [selectedProjectId]);

  // Handle USP text change
  const handleTextChange = (index, text) => {
    setUsps((prev) =>
      prev.map((usp, i) => (i === index ? { ...usp, text } : usp))
    );
  };

  // Add new USP row
  const handleAddNew = () => {
    setUsps((prev) => [
      ...prev,
      { id: `newusp${prev.length + 1}`, text: '' }
    ]);
  };

  // Remove USP row
  const handleRemove = (index, id) => {
    setUsps((prev) => prev.filter((_, i) => i !== index));
    if (id && !String(id).startsWith('newusp')) {
      setRemovedIds((prev) => [...prev, id]);
    }
  };

// Submit handler (only array of strings)
const updateProjectUsps = async (e) => {
  e.preventDefault();
  const buttons = document.getElementsByClassName('theme-btn');
  for (let button of buttons) {
      button.disabled = true;
  }
  setButtonClass(`${buttonClass.current} ${buttonLoadingClass}`);

   try {
        const uspsData = usps.map((usp) => usp.text || '');
        if (uspsData.length > 0) {
            const updatedProjectUspsData = await executeLaravelAPI(`projectusps/edit/${selectedProjectId}`, uspsData, 'PUT', userToken);
            if (updatedProjectUspsData.status === 200) {
                showToastMessage('USPs are updated successfully', 'top-right', 'success');
            } else {
                showToastMessage('USPs are not updated successfully', 'top-right', 'error');
            }
        }
        
    } catch (error) {
        console.error('Error updating USPs:', error);
        // Show user-friendly error message based on error type
        if (error.message && error.message.includes('Failed to fetch')) {
            showToastMessage('Connection failed. If the problem persists, please check your internet connection or VPN', 'top-right', 'error');
        } else {
            showToastMessage('Error updating USPs. Please try again.', 'top-right', 'error');
        }
    } finally {
        // Reset the button class and enable all the buttons
        setButtonClass(buttonClass.current);
        for (let button of buttons) {
            button.disabled = false;
        }
    }
};

  return (
    <form onSubmit={updateProjectUsps} className="projectForm">
      <div className="row">
        <div className="col-md-12 mb-2">
          <table className="table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table usp-table">
            <thead>
              <tr className="table-secondary">
                <td>No.</td>
                <td>USP</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-outline-success rounded-circle add-config text-success"
                    onClick={handleAddNew}
                    title="Add new USP row"
                  >
                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                  </button>
                </td>
              </tr>
            </thead>
            <tbody className="uspstbody">
              {usps && Array.isArray(usps) && usps.map((usp, index) => (
                <tr key={usp.id || index}>
                  <td style={{ verticalAlign: 'middle' }}>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={usp?.text || ''}
                      onChange={(e) => handleTextChange(index, e.target.value)}
                      placeholder="Enter USP"
                    />
                  </td>
                  <td>
                    <a
                      href="#remove"
                      onClick={(ev) => {
                        ev.preventDefault();
                        handleRemove(index, usp.id);
                      }}
                      rel="noopener noreferrer"
                      title="Remove USP"
                    >
                      <Icon
                        icon="ion:close-outline"
                        style={{ fontSize: '26px', color: '#192951' }}
                      />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="text-end mt-3">
        <SubmitButton
          type="submit"
          className={buttonClassLoader}
          label="Update USP"
        />
      </div>
    </form>
  );
};

export default ProjectUspTab;
